<div class="title-info-refunds">
  <img src="../../../../../public/assets/images/user-notification.svg" alt="" />
  <p>{{ 'homePage.refundsTitle' | translate }}</p>
</div>
<div class="body-info-refunds">
  <p class="header-card">{{ 'homePage.refundsHeader' | translate }}</p>
  <div class="request">
    <a href="https://app.myassistance.eu/"
      >{{ 'homePage.request' | translate }}<img src="../../../../../public/assets/images/icon-arrow.svg" style="margin-left: 10px"
    /></a>
  </div>
  <div class="text-info">
    <img src="../../../../../public/assets/images/call.svg" alt="" />
    <div>
      <p><b>800.031.913</b> {{ 'homePage.refundsHomePhone' | translate }}</p>
      <p><b>+39 02303500031</b> {{ 'homePage.refundsCellPhone' | translate }}</p>
    </div>
  </div>
  <div class="text-info" style="margin-top: 0.5rem">
    <img src="../../../../../public/assets/images/mail-red.svg" alt="" />
    <div>
      <a>{{ 'homePage.refundsEmail' | translate }}</a>
    </div>
  </div>
</div>
